module.exports = __webpack_public_path__ + "static/media/2DGACM15.73b573a6.jpg";